import React, { Component } from 'react'
import { withRouter } from 'react-router'
import PropTypes from 'prop-types'
import './styles.css'

class Breadcrumbs extends Component {
  static get propTypes() {
    return {
      config: PropTypes.array.isRequired,
      history: PropTypes.object.isRequired
    }
  }

  render() {
    const onClick = (url, evt) => {
      evt.preventDefault()
      this.props.history.push(url)
      return false
    }
    const items = this.props.config.map(i => {
      if (i.url) {
        return (
          <li className="breadcrumb-item" key={i.title.toLowerCase()}>
            <a href={i.url} onClick={(evt) => onClick(i.url, evt)}>{i.title}</a>
          </li>)
      } else {
        return (<li key={i.title.toLowerCase()} className="breadcrumb-item active" aria-current="page">{i.title}</li>)
      }
    })
    return (
      <div className='components-breadcrumbs'>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            {items}
          </ol>
        </nav>
      </div>
    )
  }
}

export default withRouter(Breadcrumbs)
